import { Moon, Sun } from 'lucide-react';
import { useTheme } from '@/providers';
import { cn } from '@/utils/cn';

interface ThemeToggleProps {
  className?: string;
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={cn(
        'relative inline-flex items-center justify-center w-9 h-9 rounded-xl',
        'border border-border/80 dark:border-white/[0.1] bg-background/80 dark:bg-card/80',
        'hover:bg-muted/80 dark:hover:bg-muted/50 text-foreground',
        'transition-all duration-200 ease-out active:scale-95',
        'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        'shadow-xs overflow-hidden group',
        className
      )}
      aria-label={isDark ? 'Alternar para modo claro' : 'Alternar para modo escuro'}
      title={isDark ? 'Alternar para modo claro' : 'Alternar para modo escuro'}
    >
      <Sun
        size={18}
        className={cn(
          'text-amber-500 transition-all duration-300 absolute',
          isDark ? 'rotate-0 scale-100 opacity-100' : '-rotate-90 scale-0 opacity-0'
        )}
      />
      <Moon
        size={18}
        className={cn(
          'text-slate-700 dark:text-blue-300 transition-all duration-300 absolute',
          isDark ? 'rotate-90 scale-0 opacity-0' : 'rotate-0 scale-100 opacity-100'
        )}
      />
      <span className="sr-only">
        {isDark ? 'Ativar modo claro' : 'Ativar modo escuro'}
      </span>
    </button>
  );
}
